import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { DragSource,DropTarget } from 'react-dnd';
import ItemTypes from '../../ItemTypes.js';
import Toolbar from './Toolbar.js';
import DroppableElement from './DroppableElement.js';

const cardSource = {
	beginDrag(props) {
		return {
			type: props.type,
			sorting: props.element.sorting,
			id: props.element.id,
			rowId:props.element.rowId,
			col:props.element.col
		};
	}
};

function collect(connect, monitor) {
	return {
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging()
	};
}
function collectDrop(connect, monitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDropTarget: connect.dropTarget(),
        // You can ask the monitor about the current drag state:
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
        itemType: monitor.getItemType()
    };
}

const propTypes = {

	// Injected by React DnD:
	moveElement: PropTypes.func.isRequired
};


const chessSquareTarget = {
    canDrop(props, monitor) {
        const item = monitor.getItemType();
        return true;
    },

    hover(props, monitor, component) {
    	return;
    },

    drop(props, monitor, component) {
        if (monitor.didDrop()) {
            return;
        }

        const item = monitor.getItem();

        let drag = {
	    	index:item.sorting,
	    	id:item.id,
	    	rowId:item.rowId,
	    	col:item.col
	    };

	    let hover = {
	    	index:1,
	    	id:false,
	    	rowId:props.rowId,
	    	col:props.col
	    };

	   
	    // Time to actually perform the action
	 	props.moveElement(drag, hover);
    }
};


class DropContentElement extends React.Component {
	constructor(props) {	
		super(props);
		
	}

	render() {
		const { isDragging, connectDragPreview,connectDragSource,connectDropTarget } = this.props;


		return connectDropTarget(
			<div className="empty-column">
				{this.props.children}
			</div>
		);
	}
}

DropContentElement.propTypes = propTypes;
export default DropTarget([ItemTypes.NEW_ELEMENT,ItemTypes.ELEMENT], chessSquareTarget, collectDrop)(DropContentElement);



// WEBPACK FOOTER //
// ./components/builder/DropContentElement.js